<template>
  <v-card v-if="verifCancelEvent == false" rounded="lg">
    <v-card-title class="pa-3 d-flex align-center" style="background:#F5F5F5; border-bottom:1px solid #E0E0E0">
      <v-icon color="#5C6BC0" class="mr-2">mdi-wrench-outline</v-icon>
      <span style="font-size:15px; font-weight:700">{{ eventData['N° RAP COMP'] }}</span>
      <v-spacer></v-spacer>
      <v-btn icon variant="text" size="small" @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <div class="pa-2">
    <v-col class="pa-0">
      <v-table density="compact" style="font-size:14px; border:1px solid #E0E0E0; border-radius:6px; overflow:hidden">
        <tbody>
          <tr v-for="(elem, idx) in getFormatedEventData" :key="idx"
            :style="idx % 2 === 0 ? 'background-color:#F5F5F5' : 'background-color:white'">
            <td style="padding:6px 10px; font-weight:600; color:#616161; white-space:nowrap; width:35%">{{ elem.key }}</td>
            <td style="padding:6px 10px; color:#212121">{{ elem.value }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-col>
    <v-col class="px-0" v-if="infoTabSorted" style=" font-size: 17px;">
      <div style="max-height: 25vh;overflow-y: auto;">
        <v-row style="
          background-color: #EEEEEE;
              border: solid 1px lightgrey;
              width: 100%;
              margin: 10px 0px;
              padding: 1px;
            ">
          <v-col v-for="elem in infoTabSorted.headers" :key="elem" style="text-transform: uppercase;">
            {{ elem }}
          </v-col>
        </v-row>
        <table style="
          background-color: #EEEEEE;
              border: solid 1px lightgrey;
              width: 100%;
              margin: 10px 0px;
              padding: 1px;
            ">

          <tr v-for="line in infoTabSorted.items" :key="line">
            <td v-for="elem in line" :key="elem"
              style="padding: 5px; border: solid 1px lightgrey;background-color:white;">
              {{ elem }}
            </td>
          </tr>
        </table>
      </div>
    </v-col>
    <v-col :class="!infoTabSorted ? 'mt-2' : ''">
      <v-row style="
            background-color: #EEEEEE;
            border: solid 1px lightgrey;
            font-weight: bold;
          " justify="center" align="center">
        <v-col v-if="eventColorByIdFiltered[110]" cols="" align="center" class="button-state" style="border-radius:0px;"
          :style="eventState == '110' ? getStaturBarStyle : ''">
          Planifié
        </v-col>
        <v-divider vertical></v-divider>
        <v-col v-if="eventColorByIdFiltered[120]" cols="" align="center" class="button-state" style="border-radius:0px;"
          :style="eventState == '120' ? getStaturBarStyle : ''">
          Envoyé sur tablette
        </v-col>
        <v-divider vertical></v-divider>
        <v-col v-if="eventColorByIdFiltered[130]" cols="" align="center" class="button-state" style="border-radius:0px;"
          :style="eventState == '130' ? getStaturBarStyle : ''">
          Récupéré
        </v-col>
        <v-divider vertical></v-divider>
        <v-col v-if="eventColorByIdFiltered[140]" cols="" align="center" class="button-state" style="border-radius:0px;"
          :style="eventState == '140' ? getStaturBarStyle : ''">
          Terminé
        </v-col>
      </v-row>
    </v-col>
    <!-- <div style="
            width: 100%;
            border: solid 1px lightgrey;
            height: 11px;
          " class="mt-1">
      <div style="height: 9px" :style="getStaturBarStyle"></div>
    </div> -->

    <v-divider class="mt-2"></v-divider>
    <v-card-actions class="pa-3">
      <div v-if="isRoot" class="d-flex flex-wrap gap-2">
        <v-btn v-if="eventState <= 130" @click="verifCancelEvent = true" variant="flat"
          color="#BF360C" style="color:white" size="small">
          <v-icon size="16" class="mr-1">mdi-calendar-remove</v-icon>Annuler planification
        </v-btn>
        <v-btn v-if="eventState <= 110 && eventColorByIdFiltered[120]" @click="sendToTablette()"
          variant="flat" style="color:white" size="small"
          :style="{ 'background-color': this.eventColorById[120].color }">
          <v-icon size="16" class="mr-1">mdi-tablet</v-icon>
          Envoyer vers <strong class="mx-1" style="background:rgba(255,255,255,0.2); padding:1px 5px; border-radius:4px">{{ this.eventData["Technicien"][0] }}</strong>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn @click="closeModal" variant="text" size="small">
        <v-icon size="16" class="mr-1">mdi-close</v-icon>Fermer
      </v-btn>
    </v-card-actions>
    </div>
  </v-card>
  <v-card v-else rounded="lg">
    <v-card-title class="pa-4 d-flex align-center" style="background:#FFF3E0">
      <v-icon color="orange-darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
      <span style="font-size:15px; font-weight:700">Confirmation d'annulation</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-4 text-center" style="font-size:15px">
      Êtes-vous sûr de vouloir annuler cette intervention ?
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn variant="text" @click="verifCancelEvent = false">Non</v-btn>
      <v-btn color="success" variant="flat" style="color:white" @click="cancelEvent">
        <v-icon class="mr-1" size="18">mdi-check</v-icon>Oui, annuler
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import planningTechnicien from "../core/index";
import moment from "moment";

export default {
  data() {
    return {
      eventState: 100,
      verifCancelEvent: false,
      infoTabSorted: undefined,
    };
  },
  props: {
    optionsPlanning: {},
    eventData: {},
    eventColorByIdFiltered: {},
    eventColorById: {},
    isRoot: {},
  },
  methods: {
    setState(val) {
      this.eventState = val;
    },
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save", { id: this.eventData.id, Statut: this.eventState });
    },
    sendToTablette() {
      // {{ optionsPlanning.find((val) => val.key == "use_accen_tablette") }}
      if (this.optionsPlanning && this.optionsPlanning.find((val) => val.key == "use_accen_tablette")) {
        if (this.optionsPlanning.find((val) => val.key == "use_accen_tablette").value == 0)
          this.$emit("save", { id: this.eventData.id, Statut: "130" });
        else
          this.$emit("save", { id: this.eventData.id, Statut: "120" });
      }
      else
        this.$emit("save", { id: this.eventData.id, Statut: "120" });
    },
    cancelEvent() {
      this.$emit("save", { id: this.eventData.id, Statut: "100" });
    },
  },
  mounted() {
    let that = this;
    planningTechnicien.get_event_info_by_event_link(
      this.eventData["_LINK MOTEUR"],
      function (data) {
        if (data.code == 0) {
          let infoTabSorted = {
            headers: ["Référence", "Désignation", "Quantitée"],
            items: [],
          };
          let infoTab = data.data.data;
          for (let i = 0; i < infoTab.length; i++) {
            infoTabSorted.items.push([
              infoTab[i].fieldData["SAV REF PRODUIT"],
              infoTab[i].fieldData["SAV DESIGNATION"],
              infoTab[i].fieldData["SAV QTE PROD"],
            ]);
          }
          that.infoTabSorted = infoTabSorted;
        }
      }
    );
    this.eventState = this.eventData["Statut"];
  },
  computed: {
    getAccenUrl() {
      return (
        // "fmp://172.16.1.42/Sav.fmp12?script=affiche_contrat&param=" +
        "fmp://10.20.23.11/Sav.fmp12?script=affiche_or&param=" +
        this.eventData["N° RAP COMP"]
      );
    },
    isBtnSelectedStyle() {
      return "background-color: grey;color: white;";
    },
    getStaturBarStyle() {
      if (this.eventState == 110 && this.eventColorById[this.eventState])
        return {
          width: "25%",
          "background-color": this.eventColorById[this.eventState].color,
          color: 'white'
        };
      if (this.eventState == 120 && this.eventColorById[this.eventState])
        return {
          width: "50%",
          "background-color": this.eventColorById[this.eventState].color,
          color: 'white'
        };
      if (this.eventState == 130 && this.eventColorById[this.eventState])
        return {
          width: "75%",
          "background-color": this.eventColorById[this.eventState].color,
          color: 'white'
        };
      if (this.eventState == 140 && this.eventColorById[this.eventState])
        return {
          width: "100%",
          "background-color": this.eventColorById[this.eventState].color,
          color: 'white'
        };
      return {
        width: "0%",
        "background-color": this.eventColorById[this.eventState].color,
        color: 'white'
      };
    },
    getFormatedEventData() {
      let formatedEventData = [];
      let keyNameToshow = {
        "N° RAP COMP": { value: "N° RAP COMP", idx: 0 },
        societeliv: { value: "Société", idx: 1 },
        adliv: { value: "Adresse", idx: 2 },
        villeliv: { value: "Ville", idx: 3 },
        Telephone: { value: "Téléphone", idx: 4 },
        Debut: { value: "Début", idx: 5 },
        Fin: { value: "Fin", idx: 6 },
        Technicien: { value: "Technicien", idx: 7 },
        "Theme devis": { value: "Travaux demandé", idx: 8 },
        "N° MATR INT": { value: "N° MATR INT", idx: 9 },
        "MARQUE MACHINE": { value: "MARQUE MACHINE", idx: 10 },
        "N° serie constr.": { value: "N° SERIE CONSTR", idx: 11 },
        "TYPE MACHINE": { value: "TYPE MACHINE", idx: 12 },
        Message_Interne: { value: "Message interne", idx: 13 },
      };
      for (const [key, value] of Object.entries(this.eventData)) {
        if (
          key !== "id" &&
          key !== "_LINK MOTEUR" &&
          key !== "Statut" &&
          key !== "compadliv" &&
          key !== "ID_Agence"
        ) {
          let name = key;
          let dataValue = value;
          if (keyNameToshow[key].value) {
            name = keyNameToshow[key].value;
          }
          if (key === "adliv") {
            if (this.eventData["compadliv"])
              dataValue += " / " + this.eventData["compadliv"];
          }
          if (key === "Debut" || key === "Fin") {
            dataValue = moment(dataValue).format("DD/MM/YYYY HH:mm");
          }
          if (key === "Technicien") {
            try {
              dataValue = dataValue.filter((val) => val != null).join(" - ");
            } catch {
              true;
            }
          }
          formatedEventData.push({
            key: name,
            value: dataValue,
            idx: keyNameToshow[key].idx,
          });
        }
      }
      return formatedEventData.sort((a, b) => {
        return a.idx - b.idx;
      });
    },
  },
};
</script>

<style></style>